module.exports = " <div class=\"checkbox-input clearfix\"> <div class=form-group> <label v-bind:for=field.name class=\"col-sm-4 control-label\">{{ field.label }} <span v-if=field.required class=required>*</span></label> <div class=col-sm-8> <div class=checkbox> <label> <input v-bind:id=field.name type=checkbox v-model=field.value v-bind:name=field.name /> <i v-if=field.icon v-bind:class=\"'fa ' + field.icon + ' fa-lg'\"></i> {{ field.checkboxLabel }} </label> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/CheckboxInput.vue
// module id = 725
// module chunks = 2